<template>
  <main>
    <div class="container">
      <div class="page_content" v-html="htmlContent" />
    </div>
  </main>
</template>

<script setup lang="ts">
import type { IStagesOfWorkPage } from '@/types';

const { findOne } = useStrapi();
const response = await findOne<IStagesOfWorkPage>('page-stages-of-work', {
  populate: 'deep',
});

const data = response.data as unknown as IStagesOfWorkPage;

useHead(usePageSeoMeta(data));

const htmlContent = data.content;
</script>
